let JumbotronMitra = () => {
  return (
    <>
      <div>
        <section className="jumbotron jumbotron-fluid jumbotron-gradation">
          <div className="h-100 d-flex justify-content-center jumbotron-content">
            <div className="my-auto text-center">
              <p className="jumbotron-title">Mitra</p>
              <span className="jumbotron-text">
                Yuk Menjadi Mitra Untuk Mendapatkan Bantuan Modal dari Investor
              </span>
              <div className="to-down">
                <div className="arrow bounce">
                  <i
                    className="fa fa-angle-down fa-4x clicked"
                    aria-hidden="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="box px-5" data-aos="fade-up">
          <div className="container boxess">
            <div className="row mx-auto h-100">
              <div className="col-md-12 my-auto h-100 p-3">
                <h1 className="text-green">
                  Anda punya keahlian bertani, punya lahan tapi tidak punya
                  modal?
                </h1>
              </div>
            </div>
          </div>
        </section>
        <br />
      </div>
    </>
  );
};
export default JumbotronMitra;
